import { useActiveAddress } from "../hooks/useActiveAddress";
import { DEFAULT_ADMIN_WALLETS } from "../config";

/**
 * Admin access is restricted to the single configured admin wallet
 * (REACT_APP_FUTUREX_DEFAULT_ADMIN). No other wallet is let into the console,
 * whatever roles it may hold on-chain.
 * Returns { isPollManager, isFeeManager, isDefaultAdmin, isConfigAdmin, isAnyAdmin }.
 */
export function useIsAdmin() {
    const address = useActiveAddress();
    const isConfigAdmin = Boolean(address) && DEFAULT_ADMIN_WALLETS.includes(address?.toLowerCase());

    return {
        isPollManager: isConfigAdmin,
        isFeeManager: isConfigAdmin,
        isDefaultAdmin: isConfigAdmin,
        isConfigAdmin,
        isAnyAdmin: isConfigAdmin,
    };
}
